// extracted by mini-css-extract-plugin
module.exports = {"note_slider":"NoteSlider_note_slider__1OeqS"};